import {
  SET_PAGINATION,
  SET_CURRENCY,
  SET_ALLOWED_CURRENCIES,
  TRANSACTIONHISTORY_REQUEST,
  TRANSACTIONHISTORY_SUCCESS,
  TRANSACTIONHISTORY_FAILURE,
  ALLOWED_CURRENCIES_REQUEST,
  ALLOWED_CURRENCIES_SUCCESS,
  ALLOWED_CURRENCIES_FAILURE,
  CLEANUP,
} from "./transactionHistoryType";

const initialState = {
  loading: false,
  currency: "ALL",
  allowedCurrencies: [],
  transactionHistory: [],
  pagination: {
    current: 0,
    pageSize: 20,
    total: 0,
  },
  error: "",
};

const transactionHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEANUP: {
      return initialState;
    }

    case SET_CURRENCY: {
      return {
        ...state,
        currency: action.currency,
      };
    }

    case SET_ALLOWED_CURRENCIES: {
      return {
        ...state,
        allowedCurrencies: action.allowedCurrencies,
      };
    }

    case SET_PAGINATION: {
      return {
        ...state,
        pagination: action.pagination,
      };
    }

    case TRANSACTIONHISTORY_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case TRANSACTIONHISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        transactionHistory: action.payload.data,
        pagination: {
          current: action.payload.page+1,
          size: action.payload.size,
          total: action.payload.total,
        },
        error: "",
      };
    }

    case TRANSACTIONHISTORY_FAILURE: {
      return {
        ...state,
        loading: false,
        transactionHistory: [],
        error: action.payload,
      };
    }

    case ALLOWED_CURRENCIES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case ALLOWED_CURRENCIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        allowedCurrencies: action.payload,
        error: "",
      };
    }

    case ALLOWED_CURRENCIES_FAILURE: {
      return {
        ...state,
        loading: false,
        allowedCurrencies: [],
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export default transactionHistoryReducer;
